(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('TransactionsConfig', TransactionsConfig);

  function TransactionsConfig(PageConfig, Section, Chart, SeriesService, CalloutLabelService, UserCohort,
                              ConsumerChartDisplay, StandardReports){

    var conversion = Section("conversion", PageConfig.transactionSummary,
        Chart("conversion", "line", "percent", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value}),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value }) ]
        ),
        [ StandardReports.calloutOptions("RelativeConversionLift", [ CalloutLabelService.lift(false) ]),
          StandardReports.calloutOptions("Conversion", [ CalloutLabelService.tf(false),
            CalloutLabelService.nonTF(false), CalloutLabelService.sitewide(false)])],
        StandardReports.sectionOptions('conversions',null, '%')
    );

    var orders = function(section) {
      return Section("orders", PageConfig.transactionSummary,
          Chart("orders", "line", "values", section,
              [SeriesService.tf({userCohort: UserCohort.tf.value, isBot: false, isMatched: true}),
                SeriesService.nonTF({userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true})]
          ),
          [StandardReports.calloutOptions("TotalUsedForReporting", [CalloutLabelService.tf(true), CalloutLabelService.nonTF(true)])],
          StandardReports.sectionOptions('orders')
      );
    };

    var sessions = function(section) {
      return Section("sessions", PageConfig.transactionSummary,
          Chart("sessions", "line", "values", section,
              [SeriesService.tf({userCohort: UserCohort.tf.value, isBot: false}),
                SeriesService.nonTF({userCohort: UserCohort.nonTF.value, isBot: false})]
          ),
          [StandardReports.calloutOptions("TotalUsedForReporting", [CalloutLabelService.tf(true), CalloutLabelService.nonTF(true)])],
          StandardReports.sectionOptions('sessions')
      );
    };

    var ordersForConversion =  Section("ordersForConversion", PageConfig.orders,
        Chart("ordersForConversion", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false, isMatched: true }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true }) ]
        ),
        [ StandardReports.calloutOptions("TotalUsedForReporting", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true) ]) ],
        StandardReports.sectionOptions('orders')
    );

    var totalOrders = Section("totalOrders", PageConfig.orders,
        Chart("totalOrders", "area", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false, isMatched: true }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true }),
              SeriesService.sitewideWithBots(function (value) { return value.isBot || !value.isMatched; }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.all, ConsumerChartDisplay.Colors.totalLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.all, ConsumerChartDisplay.Colors.totalLine)])],
        StandardReports.sectionOptions('orders')
    );

    var tfOrders = Section("tfOrders", PageConfig.orders,
        Chart("tfOrders", "area", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false, isMatched: true }),
              SeriesService.tfWithBots(function (value) { return value.userCohort === UserCohort.tf.value &&
                  (value.isBot || !value.isMatched); }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.tf, ConsumerChartDisplay.Colors.tfLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.tf, ConsumerChartDisplay.Colors.tfLine)])],
        StandardReports.sectionOptions('orders')
    );

    var nonTFOrders = Section("nonTFOrders", PageConfig.orders,
        Chart("nonTFOrders", "area", "values", false,
            [ SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true }),
              SeriesService.nonTFWithBots(function (value) { return value.userCohort === UserCohort.nonTF.value &&
                  (value.isBot || !value.isMatched); }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalReporting", [
          CalloutLabelService.sectionTotal(false, UserCohort.nonTF, ConsumerChartDisplay.Colors.nonTFLine) ]),
          StandardReports.calloutOptions("TotalUsedForReporting", [
            CalloutLabelService.usedForReporting(false, UserCohort.nonTF, ConsumerChartDisplay.Colors.nonTFLine)])],
        StandardReports.sectionOptions('orders')
    );

    var revenue = Section("revenue", PageConfig.revenue,
        Chart("revenue", "area", "values", false,
            [ SeriesService.tf(function(v){ return v.userCohort === UserCohort.tf.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.nonTF(function(v){ return v.userCohort === UserCohort.nonTF.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.sitewideWithBots(function(v){ return v.userCohort === UserCohort.all.value && v.isBot && _.isUndefined(v.isMatched) }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalRevenue",
            [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true), CalloutLabelService.sitewideWithBots(false)])
        ],
        StandardReports.sectionOptions('revenue', '$')
    );

    var aov = Section("aov", PageConfig.revenue,
        Chart("aov", "line", "values", false,
            [ SeriesService.tf(function(v){ return v.userCohort === UserCohort.tf.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.nonTF(function(v){ return v.userCohort === UserCohort.nonTF.value && !v.isBot && _.isUndefined(v.isMatched) }),
            ]
        ),
        [ StandardReports.calloutOptions("RelativeAOVLift", [ CalloutLabelService.change(false) ]),
          StandardReports.calloutOptions("MeanAOV", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
            CalloutLabelService.sitewide(false)])
        ],
        StandardReports.sectionOptions('revenue', '$')
    );

    var rps = Section("rps", PageConfig.revenue,
        Chart("rps", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false,isMatched: true }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false,isMatched: true }),
            ]
        ),
        [ StandardReports.calloutOptions("RevenuePerSessionLift", [ CalloutLabelService.change(false) ]),
          StandardReports.calloutOptions("MeanRPS", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
            CalloutLabelService.sitewide(false)])
        ],
        StandardReports.sectionOptions('revenue-per-session', '$')
    );

    var arpu = Section("arpu", PageConfig.revenue,
        Chart("arpu", "line", "values", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false,isMatched: true }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false,isMatched: true }),
            ]
        ),
        [ StandardReports.calloutOptions("ARPULift", [ CalloutLabelService.change(false) ]),
          StandardReports.calloutOptions("MeanARPU", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
            CalloutLabelService.sitewide(false)])
        ],
        StandardReports.sectionOptions('average-revenue-per-user', '$')
    );

    var mrps = Section("mrps", PageConfig.revenue,
      Chart("mrps", "line", "values", false,
          [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false,isMatched: true }),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false,isMatched: true }),
          ]
      ),
      [ StandardReports.calloutOptions("MonthlyRevenuePerSessionLift", [ CalloutLabelService.change(false) ]),
          StandardReports.calloutOptions("MeanMRPS", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
              CalloutLabelService.sitewide(false)])
      ],
      StandardReports.sectionOptions('monthly-revenue-per-session', '$')
    );

    var upt = Section("upt", PageConfig.revenue,
        Chart("upt", "line", "ratio", false,
            [ SeriesService.tf(function(v){ return v.userCohort === UserCohort.tf.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.nonTF(function(v){ return v.userCohort === UserCohort.nonTF.value && !v.isBot && _.isUndefined(v.isMatched) }),
            ]
        ),
        [ StandardReports.calloutOptions("RelativeUPTLift", [ CalloutLabelService.change(false) ]),
          StandardReports.calloutOptions("MeanUPT", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
            CalloutLabelService.sitewide(false)])
        ],
        StandardReports.sectionOptions('revenue')
    );

    var units = Section("units", PageConfig.revenue,
        Chart("units", "area", "values", false,
            [ SeriesService.tf(function(v){ return v.userCohort === UserCohort.tf.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.nonTF(function(v){ return v.userCohort === UserCohort.nonTF.value && !v.isBot && _.isUndefined(v.isMatched) }),
              SeriesService.sitewideWithBots(function(v){ return v.userCohort === UserCohort.all.value && v.isBot && _.isUndefined(v.isMatched) }, null, null, true)
            ]
        ),
        [ StandardReports.calloutOptions("TotalUnits",
            [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true), CalloutLabelService.sitewideWithBots(false)])
        ],
        StandardReports.sectionOptions('revenue')
    );

    var monthlyOrders = function (section) {
      return Section("monthlyOrders", PageConfig.orderRate,
          Chart("monthlyOrders", "line", "values", section,
              [ SeriesService.tf({ userCohort: UserCohort.tf.value, isBot: false, isMatched: true  }),
                SeriesService.nonTF({ userCohort: UserCohort.nonTF.value, isBot: false, isMatched: true  }),
                SeriesService.sitewideWithBots({ userCohort: UserCohort.all.value }),
              ]
          ),
          [ StandardReports.calloutOptions("MeanMonthlyOrders", [ CalloutLabelService.tf(true), CalloutLabelService.nonTF(true),
            CalloutLabelService.sitewide(false)]) ],
          StandardReports.sectionOptions('monthly-orders')
      );
    };

    var monthlyUsers = function (section) {
      return Section("mau", PageConfig.orderRate,
          Chart("mau", "line", "values", section,
              [SeriesService.tf({userCohort: UserCohort.tf.value, isBot: false}),
                SeriesService.nonTF({userCohort: UserCohort.nonTF.value, isBot: false})
              ]
          ),
          [StandardReports.calloutOptions("MeanUserCountUsedForReporting", [CalloutLabelService.tf(true),
            CalloutLabelService.nonTF(true), CalloutLabelService.sitewide(false)])],
          StandardReports.sectionOptions('monthly-users')
      );
    };

    var ordersPerUser = Section("ordersRate", PageConfig.orderRate,
        Chart("ordersRate", "line", "ratio", false,
            [ SeriesService.tf({ userCohort: UserCohort.tf.value}),
              SeriesService.nonTF({ userCohort: UserCohort.nonTF.value})
            ]
        ),
        [ StandardReports.calloutOptions("MeanORPU", [ CalloutLabelService.tf(false), CalloutLabelService.nonTF(false),
          CalloutLabelService.sitewide(false)]) ],
        StandardReports.sectionOptions('monthly-orders-per-user')
    );

    return {
      conversion: conversion,
      orders: orders,
      sessions: sessions,

      ordersForConversion: ordersForConversion,
      totalOrders: totalOrders,
      tfOrders: tfOrders,
      nonTFOrders: nonTFOrders,

      revenue: revenue,
      aov: aov,
      rps: rps,
      arpu: arpu,
      mrps:mrps,
      upt: upt,
      units: units,

      monthlyOrders: monthlyOrders,
      monthlyUsers: monthlyUsers,
      ordersPerUser: ordersPerUser

    };

  }
})();